import { PatientService } from "../fhir/PatientService";
import { PractitionerService } from "../fhir/PractitionerService";
import { ActorModel } from "../fhir/fhir.types";

export class IdentityResolutionService {
  constructor(
    private readonly patientService: PatientService,
    private readonly practitionerService: PractitionerService,
  ) {}

  async resolveByEmail(email: string): Promise<ActorModel[]> {
    const normalized = email.trim().toLowerCase();
    if (!normalized) {
      return [];
    }

    const [patients, practitioners] = await Promise.all([
      this.patientService.searchByEmail(normalized),
      this.practitionerService.searchByEmail(normalized),
    ]);

    const actors = new Map<string, ActorModel>();
    [...patients, ...practitioners].forEach((actor) =>
      actors.set(actor.reference, actor),
    );

    return Array.from(actors.values());
  }
}
